<div class="p-grid">
	<div class="p-col">
		<input
			pInputText
			type="text"
			placeholder="First Name"
			name="firstName"
			[(ngModel)]="user.firstName"
			class="m-2 w-100"
			(change)="changesToSaveChange.emit(true)"
		/>
	</div>
	<div class="p-col">
		<input
			pInputText
			type="text"
			placeholder="Last Name"
			name="lastName"
			[(ngModel)]="user.lastName"
			class="m-2 w-100"
			(change)="changesToSaveChange.emit(true)"
		/>
	</div>
</div>
<div class="p-grid">
	<div class="p-col">
		<input
			pInputText
			[disabled]="!user.unsaved || currentUserProfileEdit"
			type="email"
			placeholder="Email"
			name="email"
			[(ngModel)]="user.email"
			class="w-50 m-2 w-100"
			(change)="changesToSaveChange.emit(true)"
		/>
	</div>
	<div class="p-col">
		<input
			pInputText
			type="tel"
			placeholder="Phone"
			name="phone"
			[(ngModel)]="user.phone"
			class="w-50 m-2 w-100"
			(change)="changesToSaveChange.emit(true)"
		/>
	</div>
</div>
<div class="p-grid">
	<div class="p-col">
		<input
			pInputText
			type="text"
			placeholder="Organization"
			name="organization"
			[(ngModel)]="user.organization"
			class="w-100 m-2"
			(change)="changesToSaveChange.emit(true)"
		/>
	</div>
</div>
<div class="p-grid">
	<div class="p-col">
		<p-dropdown
			*ngIf="userService.user.role > user.role && !currentUserProfileEdit"
			placeholder="User Role"
			[options]="userRoles"
			optionLabel="label"
			optionValue="value"
			name="userRoles"
			[(ngModel)]="user.role"
			styleClass="m-2"
			[style]="{ width: '100%' }"
			appendTo="body"
			(onChange)="changesToSaveChange.emit(true)"
		></p-dropdown>
	</div>
</div>
<div class="p-grid">
	<div class="p-col">
		<p-dropdown
			*ngIf="userService.user.role > 4 && (user.role === 4 || user.role === 3) && !currentUserProfileEdit"
			placeholder="Select Dealer"
			[options]="dealerList"
			optionLabel="name"
			optionValue="key"
			name="dealers"
			[virtualScroll]="true"
			virtualScrollItemSize="30"
			filter="true"
			filterBy="name"
			[(ngModel)]="user.dealerKey"
			styleClass="m-2"
			[style]="{ width: '100%' }"
			appendTo="body"
			(onChange)="userDealerSelect(); changesToSaveChange.emit(true); dealerSelectedChange.emit(user.dealerKey)"
		></p-dropdown>
	</div>
</div>
<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="d-flex w-100">
			<div class="my-auto mx-2">Disable Menu Customization</div>

			<p-inputSwitch
				styleClass="mx-2"
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="user.disableMenuCustomization"
				[disabled]="currentUserProfileEdit"
			>
			</p-inputSwitch>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="d-flex flex-column w-100">
			<div class="d-flex w-100">
				<span class="p-float-label flex-fill">
					<p-dropdown
						#commandCenterNewOrderTone
						[options]="app.references.commandCenterTones"
						optionLabel="label"
						optionValue="value"
						name="commandCenterNewOrderTone"
						[(ngModel)]="user.commandCenterOrderNotificationTone"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						filterBy="filterByProperties"
						styleClass="w-100"
						(onChange)="changesToSaveChange.emit(true)"
					></p-dropdown>
					<label for="commandCenterNewOrderTone">New Order Tone</label>
				</span>
				<fa-icon [icon]="['far', 'play']" size="lg" class="mx-2 my-auto" (click)="app.playAudio(user.commandCenterOrderNotificationTone)"></fa-icon>
			</div>
			<div class="descriptionText">Tone will play when a new order is received for your store while you're logged into CommandCenter</div>
		</div>
	</div>
</div>
